module.exports = __webpack_public_path__ + "img/bk_12.e4c06549.png";